export const NATIVE_APP_INTERFACE_NAMES = {
  CHASE_PROMO_CLICKED: "handleChasePromoClicked",
  DISPLAY_LOGIN: "displayLogin",
  EXIT: "exit",
  LOGOUT: "logout",
  MFA_AUTHENTICATED: "mfaAuthenticated",
  PAGE_LOADING: "pageLoading",
  PAGE_RENDERED: "pageRendered",
};
